/**
 * ServerStatus — live sandbox backend status pill.
 *
 * Pings the backend on mount (which doubles as the wake-up call for sleeping
 * sandbox servers) and retries every 5s until it answers. Amber pulse while
 * warming, green when ready.
 */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function ServerStatus() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    let timer;
    const ping = async () => {
      try {
        await api.get("/", { timeout: 8000 });
        if (alive) setReady(true);
      } catch {
        if (alive) timer = setTimeout(ping, 5000);
      }
    };
    ping();
    return () => { alive = false; clearTimeout(timer); };
  }, []);

  return (
    <div
      className="ml-auto flex items-center gap-1.5 px-2.5 py-1.5 rounded-full flex-shrink-0"
      style={{
        background: ready ? "#D1FAE5" : "#FEF3C7",
        border: `1.5px solid ${ready ? "#0E5A4A" : "#F59E0B"}`,
      }}
      title={ready ? "Backend is awake and responding." : "Sandbox servers are waking up — hang tight."}
      data-testid={ready ? "server-status-ready" : "server-status-warming"}
    >
      <span
        className={`inline-block w-2 h-2 rounded-full ${ready ? "" : "animate-pulse"}`}
        style={{ background: ready ? "#059669" : "#F59E0B" }}
      />
      <span
        className="font-mono-rm text-[9px] uppercase tracking-widest whitespace-nowrap"
        style={{ color: ready ? "#0E5A4A" : "#92400E", fontWeight: 700 }}
      >
        {ready ? "Servers ready" : "Warming up…"}
      </span>
    </div>
  );
}
